'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/detail/body/body.controller'
],function(angular,SinglePageBodyController){
    var app=angular.module('app.seospider.exam.analysis.detail.body', []);
    app.controller('SinglePageBodyController',SinglePageBodyController);
    return app;
});